/**
 * Canonical highlight palette used across selection menu + mobile color picker.
 * Keep hex values in sync with EPUB color class mapping in EpubViewerSimple.
 */
export const HIGHLIGHT_COLOR_HEXES = [
  "#F28B82", // Red
  "#F7B88A", // Orange
  "#FFF59D", // Yellow (default)
  "#A5D6A7", // Green
  "#90CAF9", // Light Blue
  "#CE93D8", // Purple
];

export const DEFAULT_HIGHLIGHT_COLOR = "#FFF59D";

export const HIGHLIGHT_COLOR_I18N_KEYS = [
  "floatingToolbar.colorRed",
  "floatingToolbar.colorOrange",
  "floatingToolbar.colorYellow",
  "floatingToolbar.colorGreen",
  "floatingToolbar.colorLightBlue",
  "floatingToolbar.colorPurple",
];

export function getHighlightColorOptions(t) {
  return HIGHLIGHT_COLOR_HEXES.map((hex, index) => ({
    hex,
    name: t(HIGHLIGHT_COLOR_I18N_KEYS[index]),
  }));
}
